import _ from 'lodash';
import fileDownload from 'js-file-download';
import CustomError from '../utils/customError';

const MIME_TYPE = 'data:application/pdf;base64,';

const downloadPdf = async (contract) => {
  try {
    const dataUrl = _.startsWith(contract, MIME_TYPE, 1)
      ? contract
      : _.replace(contract, MIME_TYPE, '');

    return fetch(dataUrl)
      .then((res) => res.blob())
      .then((blob) =>
        fileDownload(blob, contract.fileName || 'CONTRATO-BC.pdf')
      );
  } catch (error) {
    throw new CustomError({
      type: 'PDF DOWNLOAD',
      message: 'Error al generar documento pdf para descarga.',
    });
  }
};

export default downloadPdf;
